// Compress + downscale an image in the browser before upload.
// Large phone photos (5-15 MB) are re-encoded as WebP at web resolution,
// which makes uploaded images load dramatically faster on the public site.
// Non-image files (PDFs), GIFs (animation) and failures pass through unchanged.
export async function compressImage(file, { maxDim = 2048, quality = 0.85 } = {}) {
  try {
    if (!file || !file.type?.startsWith("image/") || file.type === "image/gif") return file;
    if (file.size < 400 * 1024) return file; // already light
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxDim / Math.max(bitmap.width, bitmap.height));
    const w = Math.max(1, Math.round(bitmap.width * scale));
    const h = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);
    bitmap.close();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/webp", quality));
    if (!blob || blob.size >= file.size) return file; // no gain — keep original
    const base = (file.name || "image").replace(/\.[^.]+$/, "");
    return new File([blob], `${base}.webp`, { type: "image/webp" });
  } catch {
    return file;
  }
}
